import type {Subscription} from "../../client/state/SubscriptionStore";
import {Messages} from "../Messages.js";
import {BlinkGlobal} from "../UtilsLib.js";

// TODO @mustfix remove this
export function getPaymentMethodEmptySubscriptionMessage(subscription: Subscription) {
    return (!subscription.billedUserId || subscription.billedUserId === BlinkGlobal.userId) ?
        Messages.noPaymentMethodForThisSubscription :
        Messages.noPaymentMethodForThisSubscriptionGifted;
}
